import React from 'react';
import './index.css';
import App from './App';
import {SnackBarContextProvider} from "./providers/snackbar-context";
import * as serviceWorker from './serviceWorker';
import * as ReactDOMClient from 'react-dom/client';
import "@nike/eds/dist/index.css";
import {BrowserRouter} from "react-router-dom";

let triggerContainer = null;
let root = null;

///for testing purposes
// let containerId = 'root'
// triggerContainer = document.getElementById(containerId);
// root = ReactDOMClient.createRoot(triggerContainer);
// root.render(
//     <React.StrictMode>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </React.StrictMode>
// );



window.renderTrigger = (containerId, history, {locationTracker, host, permissions}) => {
    if (!triggerContainer) {
        triggerContainer = document.getElementById(containerId);
        root = ReactDOMClient.createRoot(triggerContainer);
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <SnackBarContextProvider>
                        <App history={history} locationTracker={locationTracker} host={host} permissions={permissions}/>
                    </SnackBarContextProvider>
                </BrowserRouter>
            </React.StrictMode>
        );
        serviceWorker.unregister();
    }
};

window.unmountTrigger = containerId => {
    root.unmount()
    triggerContainer = null;
    root = null;
};

if (!document.getElementById('Trigger-container')) {
    //root.render(<App />);
    serviceWorker.unregister();
}


